import React, { useMemo } from "react";
import CardComponent from "../../components/Card/CardComponent";
import LogoGs from "../../Assets/GS-Logo.png";
import LogoYBI from "../../Assets/YBI-Logo.jpeg";
import LogoTBP from "../../Assets/TBP-Logo.jpeg";
import LogoMelco from "../../Assets/MELCO-Logo.png";
import LogoTIM from "../../Assets/TimLogo.png";
import LogoCompotec from "../../Assets/compotec-logo.png";
import LogoCBI from "../../Assets/CBI-Logo.png";
import LogoMitra from "../../Assets/Mitra_logo.png";
import TableInventory from "../../components/TableInventory/TableInventory";
import PopUpComponent from "../..//components/PopUp/PopUpComponent";
import CloseLogo from "../../Assets/close_icon.png";
import { useInventory } from "./useInventory";
import TableBarangJadi from "./TableBarangJadi";
import TableKedatangan from "./TableKedatangan";
import "./Inventory.css";
import { validateRole, hasRole } from "../../util/utilFunction";
import moment from "moment";
import { bulan, constCustomer } from "../../util/constant";
import { filterMonthConstant } from "../../util/formatDate";
import SearchLogo from "../../Assets/search-icon.png";
import Select from "react-select";
import {
  formatDot,
  switchDotsAndCommas,
  numberWithCommas,
} from "../../util/utilFunction";

const Inventory = () => {
  const {
    Material,
    setCompanyPick,
    companyPick,
    subMenu,
    setSubMenu,
    dataUser,
    Crusher,
    popUpSearch,
    setPopUpSearch,
    setDataPickHistory,
    tahunPickHistory,
    setTahunPickHistory,
    bulanPickHistory,
    setBulanPickHistory,
    Pewarna,
    setValueSearch,
    dataTemp,
    handlePick,
    valueSearch,
    handleExportBarangJadi,
    setFilterStatus,
    filterStatus,
    dataFilterStatus,
    dataMonitoringKedatanganBahanTemp,
    filterMonthKedatangan,
    setFilterMonthKedatangan,
    filterYearKedatangan,
    setFilterYearKedatangan,
    filterJenisBarang,
    setJenisBarang,
    dataJenisBarang,
    popUpExportMonitoring,
    setPopUpExportMonitoring,
    filterDateExportFrom,
    setFilterDateExportFrom,
    filterDateExportUntil,
    setFilterDateExportUntil,
    handleFilterFrom,
    filterDatePopUpUntil,
    setFilterDatePopUpUntil,
    filterDatePopUpFrom,
    setIsFilter,
    today,
    setFilterDatePopUpFrom,
    handleFilterUntil,
    popUpEdit,
    handleKirimEditBarangJadi,
    kodeKirim,
    setKodeKirim,
    satuanBarang,
    setSatuanBarang,
    isiPerKemasan,
    setIsiPerKemasan,
    handlePickEdit,
    dataPickEdit,
    setPopUpEdit,
    setKodeBarang,
    kodeBarang,
    dateTempListTanggal,
    editNamaBarang,
    setEditNamaBarang,
    editStock,
    setEditStock,
    popUpNewItem,
    setPopUpNewItem,
    newMaterial,
    setNewMaterial,
    newKodeKirim,
    setNewKodeKirim,
    newKodeBarang,
    setNewKodeBarang,
    newSatuan,
    setNewSatuan,
    newIsiKemasan,
    setNewIsiKemasan,
    handleCloseAddNewItem,
    handleAddNewItem,
    newCustomer,
    setNewCustomer,
    editRunner,
    setEditRunner,
    editBerat,
    setEditBerat,
    editLevel,
    setEditLevel,
    editBahanBaku,
    setEditBahanBaku,
    editCrusher,
    setEditCrusher,
    editPewarna,
    setEditPewarna,
    editLevel1,
    setEditLevel1,
    editLevel2,
    setEditLevel2,
    editLevel3,
    setEditLevel3,
    editPendukung1,
    setEditPendukung1,
    editPendukung2,
    setEditPendukung2,
    editPendukung3,
    setEditPendukung3,
    dataRestructure,

    isPinOpen,
    setIsPinOpen,
    isPin,
    setIsPin,
    editHarga,
    setEditHarga,
    editKomposisiMaba,
    setEditKomposisiMaba,
    foundObject,
    optionListBahanBaku,
    optionListPewarna,
    optionListCrusher,

    popUpExportPenggunaanBahan,
    setPopUpExportPenggunaanBahan,
    typeExportPenggunaanBahan,
    setTypeExportPenggunaanBahan,
    handleExportLaporanFg,
    handleExportLaporanRunner,
    handleExportLaporanNgProduk,
    handleExportInventory,
    handleExportBahanBaku,
  } = useInventory();

  const handleCloseSearch = () => {
    setPopUpSearch(false);
    setFilterStatus("Status");
    setIsFilter(false);
    setFilterDatePopUpFrom(today);
    setFilterDatePopUpUntil(today);
  };

  const handleReset = () => {
    setFilterStatus("Status");
    setIsFilter(false);
    setFilterDatePopUpFrom(today);
    setFilterDatePopUpUntil(today);
  };

  let filterKedatangan = [];

  dataMonitoringKedatanganBahanTemp &&
    dataMonitoringKedatanganBahanTemp.forEach((e) => {
      let check =
        filterKedatangan && filterKedatangan.find((o) => o === e.type);
      if (!check) {
        filterKedatangan.push(e.type);
      }
    });

  const sum =
    dataFilterStatus &&
    dataFilterStatus.reduce(function (s, a) {
      return s + a.dataWeight;
    }, 0);

  const kodeKirimMap = useMemo(
    () =>
      new Map(
        (foundObject?.data || []).map((obj) => [obj.kodeBarang, obj.kodeKirim])
      ),
    [foundObject]
  );

  const getKodeKirim = (kode) => kodeKirimMap.get(kode) || "";

  return (
    <div className="container_inventory">
      {popUpExportPenggunaanBahan ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => setTypeExportPenggunaanBahan("FG")}
            >
              <input
                type="radio"
                style={{
                  cursor: "pointer",
                }}
                checked={typeExportPenggunaanBahan === "FG"}
                readOnly
              />
              <label
                style={{
                  cursor: "pointer",
                }}
              >
                FG
              </label>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => setTypeExportPenggunaanBahan("NgProduk")}
            >
              <input
                type="radio"
                style={{
                  cursor: "pointer",
                }}
                checked={typeExportPenggunaanBahan === "NgProduk"}
                readOnly
              />
              <label
                style={{
                  cursor: "pointer",
                }}
              >
                NG Produk
              </label>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => setTypeExportPenggunaanBahan("Runner")}
            >
              <input
                type="radio"
                style={{
                  cursor: "pointer",
                }}
                checked={typeExportPenggunaanBahan === "Runner"}
                readOnly
              />
              <label
                style={{
                  cursor: "pointer",
                }}
              >
                Runner
              </label>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => setTypeExportPenggunaanBahan("Crusher")}
            >
              <input
                type="radio"
                style={{
                  cursor: "pointer",
                }}
                checked={typeExportPenggunaanBahan === "Crusher"}
                readOnly
              />
              <label
                style={{
                  cursor: "pointer",
                }}
              >
                Crusher
              </label>
            </div>
            <img
              className="width_edit_logo"
              src={CloseLogo}
              onClick={() => {
                setTypeExportPenggunaanBahan("");
                setPopUpExportPenggunaanBahan(false);
                setFilterDatePopUpFrom(today);
                setFilterDatePopUpUntil(today);
              }}
              alt="edit_logo"
            />
          </div>

          <div style={{ display: "flex" }}>
            <div className="margin_right_27_qc">
              <p>Dari</p>
              <input
                type="date"
                style={{ margin: "0" }}
                className="date_pick_memo_ppic"
                value={filterDatePopUpFrom}
                onChange={(e) => setFilterDatePopUpFrom(e.target.value)}
              />
            </div>
            <div className="margin_right_27_qc">
              <p>Sampai</p>
              <input
                type="date"
                style={{ margin: "0" }}
                className="date_pick_memo_ppic"
                value={filterDatePopUpUntil}
                onChange={(e) => setFilterDatePopUpUntil(e.target.value)}
              />
            </div>
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              className="button-kirim-edit-barangJadi"
              onClick={() => {
                if (typeExportPenggunaanBahan === "FG") {
                  handleExportLaporanFg();
                } else if (typeExportPenggunaanBahan === "Runner") {
                  handleExportLaporanRunner();
                } else if (typeExportPenggunaanBahan === "NgProduk") {
                  handleExportLaporanNgProduk();
                }
              }}
            >
              Export
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpEdit ? (
        <PopUpComponent
          style={{
            width: "80%",
            marginTop: "calc(100vh - 95vh - 20px)",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p>{dataPickEdit?.material}</p>
            <img
              className="width_edit_logo"
              src={CloseLogo}
              onClick={() => setPopUpEdit(false)}
              alt="edit_logo"
            />
          </div>
          {hasRole(dataUser, "super_user") ? (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <div style={{ marginRight: "6px" }}>
                <p>Nama Barang</p>
                <input
                  value={editNamaBarang}
                  onChange={(e) =>
                    setEditNamaBarang(e.target.value.toUpperCase())
                  }
                  type="text"
                  placeholder="Nama Barang"
                  style={{ padding: "6px" }}
                />
              </div>
              <div style={{ marginRight: "6px" }}>
                <p>Stock</p>
                <input
                  value={editStock}
                  onChange={(e) => setEditStock(e.target.value)}
                  type="number"
                  placeholder="Stock"
                  style={{ padding: "6px" }}
                />
              </div>
              {isPin === "1020" ? (
                <div style={{ marginRight: "6px" }}>
                  <p>Harga</p>
                  <input
                    value={editHarga}
                    onChange={(e) => setEditHarga(e.target.value)}
                    type="number"
                    placeholder="Harga"
                    style={{ padding: "6px" }}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <div style={{ marginRight: "6px" }}>
              <p>Kode Barang</p>
              <input
                value={kodeBarang}
                onChange={(e) => setKodeBarang(e.target.value.toUpperCase())}
                type="text"
                placeholder="Kode Barang"
                style={{ padding: "6px" }}
              />
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Kode Kirim</p>
              <input
                value={kodeKirim}
                onChange={(e) => setKodeKirim(e.target.value.toUpperCase())}
                type="text"
                placeholder="Kode Kirim"
                style={{ padding: "6px" }}
              />
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Satuan Barang</p>
              <select
                value={satuanBarang}
                onChange={(e) => setSatuanBarang(e.target.value)}
                style={{ padding: "6px" }}
              >
                <option>Satuan Barang</option>
                <option value="BOX">BOX</option>
                <option value="DUS">DUS</option>
                <option value="KTG">KTG</option>
                <option value="PALET">PALET</option>
                <option value="ZAK">ZAK</option>
              </select>
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Isi Kemasan</p>
              <input
                style={{ padding: "6px" }}
                type="number"
                onWheel={(e) => e.target.blur()}
                placeholder="Isi Kemasan"
                value={isiPerKemasan}
                onChange={(e) => setIsiPerKemasan(Number(e.target.value))}
              />
            </div>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <div style={{ marginRight: "6px" }}>
              <p>Runner (gr)</p>
              <input
                style={{ padding: "6px" }}
                type="number"
                onWheel={(e) => e.target.blur()}
                placeholder="Runner"
                value={editRunner}
                onChange={(e) => setEditRunner(Number(e.target.value))}
              />
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Berat (gr)</p>
              <input
                style={{ padding: "6px" }}
                type="number"
                onWheel={(e) => e.target.blur()}
                placeholder="Berat"
                value={editBerat}
                onChange={(e) => setEditBerat(Number(e.target.value))}
              />
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Tier</p>
              <select
                value={editLevel}
                onChange={(e) => setEditLevel(e.target.value)}
                style={{ padding: "6px" }}
              >
                <option>Level</option>
                <option value="1">Level 1</option>
                <option value="2">Level 2</option>
                <option value="3">Level 3</option>
              </select>
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Bahan Baku</p>
              <Select
                options={optionListBahanBaku && optionListBahanBaku}
                className="select-item-po"
                value={editBahanBaku || ""}
                onChange={setEditBahanBaku}
              />
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Crusher</p>
              <Select
                options={optionListCrusher && optionListCrusher}
                className="select-item-po"
                value={editCrusher || ""}
                onChange={setEditCrusher}
              />
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Pewarna</p>
              <Select
                options={optionListPewarna && optionListPewarna}
                className="select-item-po"
                value={editPewarna || ""}
                onChange={setEditPewarna}
              />
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Maba (%)</p>
              <input
                style={{ padding: "6px", width: "56px" }}
                type="number"
                onWheel={(e) => e.target.blur()}
                placeholder="%"
                value={editKomposisiMaba}
                onChange={(e) => setEditKomposisiMaba(Number(e.target.value))}
              />
            </div>

            <div style={{ marginRight: "6px" }}>
              <p>Level 1</p>
              <Select
                options={dataRestructure && dataRestructure}
                className="select-item-po"
                value={editLevel1 || ""}
                onChange={setEditLevel1}
              />
            </div>

            <div style={{ marginRight: "6px" }}>
              <p>Level 2</p>
              <Select
                options={dataRestructure && dataRestructure}
                className="select-item-po"
                value={editLevel2 || ""}
                onChange={setEditLevel2}
              />
            </div>

            <div style={{ marginRight: "6px" }}>
              <p>Level 3</p>
              <Select
                options={dataRestructure && dataRestructure}
                className="select-item-po"
                value={editLevel3 || ""}
                onChange={setEditLevel3}
              />
            </div>

            <div style={{ marginRight: "6px" }}>
              <p>Pendukung 1</p>
              <Select
                options={dataRestructure && dataRestructure}
                className="select-item-po"
                value={editPendukung1 || ""}
                onChange={setEditPendukung1}
              />
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Pendukung 2</p>
              <Select
                options={dataRestructure && dataRestructure}
                className="select-item-po"
                value={editPendukung2 || ""}
                onChange={setEditPendukung2}
              />
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Pendukung 3</p>
              <Select
                options={dataRestructure && dataRestructure}
                className="select-item-po"
                value={editPendukung3 || ""}
                onChange={setEditPendukung3}
              />
            </div>
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              className="button-kirim-edit-barangJadi"
              onClick={() => handleKirimEditBarangJadi()}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpSearch ? (
        <PopUpComponent
          style={{
            width: "80%",
            marginTop: "calc(100vh - 95vh - 20px)",
            height: "90%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
              <div className="margin_right_27_qc">
                <p>Bulan</p>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <select
                    onChange={(e) => setBulanPickHistory(e.target.value)}
                    className="input_select_memo_ppic"
                    style={{ width: "100%" }}
                    value={bulanPickHistory}
                  >
                    <option disabled>Bulan</option>
                    {bulan.map((ele) => (
                      <option key={ele.value} value={ele.value}>
                        {ele.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="margin_right_27_qc">
                <p>Tahun</p>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <select
                    onChange={(e) => setTahunPickHistory(e.target.value)}
                    className="input_select_memo_ppic"
                    style={{ width: "100%" }}
                    value={tahunPickHistory}
                  >
                    <option disabled>Tahun</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                  </select>
                </div>
              </div>
              <div className="margin_right_27_qc">
                <p>Status</p>
                {subMenu === "barangJadi" ? (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <select
                      onChange={(e) => setFilterStatus(e.target.value)}
                      className="input_select_memo_ppic"
                      style={{ width: "100%" }}
                      value={filterStatus}
                    >
                      <option disabled>Status</option>
                      <option value="NonProduksi">Outgoing / Karantina</option>
                      <option value="Datang">Datang</option>
                      <option value="Kiriman">Kiriman</option>
                      <option value="Produksi">Line Produksi</option>
                    </select>
                  </div>
                ) : (
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <select
                      onChange={(e) => setFilterStatus(e.target.value)}
                      className="input_select_memo_ppic"
                      style={{ width: "100%" }}
                      value={filterStatus}
                    >
                      <option disabled>Status</option>
                      <option value="Keluar">Keluar</option>
                      <option value="Masuk">Masuk</option>
                    </select>
                  </div>
                )}
              </div>

              <div className="margin_right_27_qc">
                <p>Dari</p>
                <input
                  type="date"
                  style={{ margin: "0" }}
                  className="date_pick_memo_ppic"
                  value={filterDatePopUpFrom}
                  onChange={(e) => handleFilterFrom(e)}
                />
              </div>
              <div className="margin_right_27_qc">
                <p>Sampai</p>
                <input
                  type="date"
                  style={{ margin: "0" }}
                  className="date_pick_memo_ppic"
                  value={filterDatePopUpUntil}
                  onChange={(e) => handleFilterUntil(e)}
                />
              </div>

              <div style={{ display: "flex", alignItems: "end" }}>
                <p
                  className="btn_reset_search_inventory"
                  style={{ margin: "0px" }}
                  onClick={() => handleReset()}
                >
                  Reset
                </p>
              </div>
              <div style={{ display: "flex", alignItems: "end" }}>
                <p
                  className="btn_reset_search_inventory"
                  style={{ margin: "0px", background: "green" }}
                  onClick={() => handleExportInventory()}
                >
                  Export
                </p>
              </div>
            </div>
            <img
              className="width_edit_logo"
              src={CloseLogo}
              onClick={() => handleCloseSearch()}
              alt="edit_logo"
            />
          </div>
          <br />

          <div className="table_inventory_mobile popUp_history_search">
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td
                    className="font_td_laporan_bahan_baku"
                    style={{
                      padding: "12px 6px",
                      lineHeight: "18px",
                    }}
                  ></td>
                  <td
                    className="font_td_laporan_bahan_baku"
                    style={{ padding: "12px 6px" }}
                  ></td>
                  <td
                    className="font_td_laporan_bahan_baku"
                    style={{ padding: "12px 6px" }}
                  >
                    <b>TOTAL</b>
                  </td>
                  <td
                    className="font_td_laporan_bahan_baku"
                    style={{ padding: "12px 6px", letterSpacing: "0.5px" }}
                  >
                    {formatDot(
                      switchDotsAndCommas(numberWithCommas(sum && sum))
                    )}
                  </td>
                  <td
                    className="font_td_laporan_bahan_baku"
                    style={{ padding: "12px 6px", letterSpacing: "0.5px" }}
                  ></td>
                  <td
                    className="font_td_laporan_bahan_baku"
                    style={{ padding: "12px 6px" }}
                  ></td>
                  <td
                    className="font_td_laporan_bahan_baku"
                    style={{ padding: "12px 6px" }}
                  ></td>
                </tr>
                <tr>
                  <th
                    className="table_header th-search-inventory"
                    style={{
                      padding: "12px 6px",
                      width: "5%",
                    }}
                  >
                    No
                  </th>
                  <th className="table_header th-search-inventory">Tanggal</th>
                  <th className="table_header th-search-inventory">Material</th>
                  <th className="table_header th-search-inventory">
                    {subMenu === "bahanBaku" ? "Jumlah (Kg)" : "Jumlah (Pcs)"}
                  </th>
                  <th className="table_header th-search-inventory">
                    {subMenu !== "bahanBaku" ? "BS (Pcs)" : ""}
                  </th>
                  <th className="table_header th-search-inventory">Status</th>
                  <th className="table_header th-search-inventory">Sisa</th>
                  <th className="table_header th-search-inventory">Operator</th>
                  <th className="table_header th-search-inventory">
                    Keterangan
                  </th>
                  <th className="table_header th-search-inventory">Expired</th>
                </tr>
                {dataFilterStatus &&
                  dataFilterStatus.map((e, index) => {
                    let dataRejectTemp = e.dataReject ? e.dataReject : 0;

                    let checkDateExp =
                      moment().utcOffset("+0700").format() <=
                      moment(e.updateTime)
                        .utcOffset("+0700")
                        .add(88, "days")
                        .format();

                    return (
                      <tr
                        key={index}
                        style={
                          index % 2 === 0
                            ? {
                                background: "white",
                                fontSize: "12px",
                              }
                            : {
                                background: "#f2f2f2",
                                fontSize: "12px",
                              }
                        }
                      >
                        <td
                          className="font_td_laporan_bahan_baku"
                          style={{
                            padding: "12px 6px",
                            lineHeight: "18px",
                          }}
                        >
                          {index + 1}
                        </td>
                        <td
                          className="font_td_laporan_bahan_baku"
                          style={{ padding: "12px 6px" }}
                        >
                          {e && moment(e.updateTime).format("ddd MMM DD YYYY")}
                        </td>
                        <td
                          className="font_td_laporan_bahan_baku"
                          style={{ padding: "12px 6px" }}
                        >
                          {e && e.material} - <b>{e && e.company}</b>
                        </td>
                        <td
                          className="font_td_laporan_bahan_baku"
                          style={
                            e && e.statusBahan === "Datang"
                              ? { padding: "12px 6px", color: "green" }
                              : e && e.statusBahan === "Kiriman"
                              ? { padding: "12px 6px", color: "red" }
                              : e.statusBahan === "Produksi" && !e.status
                              ? { padding: "12px 6px", color: "green" }
                              : e.statusBahan === "Keluar"
                              ? { padding: "12px 6px", color: "red" }
                              : e.statusBahan === "Produksi" &&
                                e.status === "Keluar"
                              ? { padding: "12px 6px", color: "red" }
                              : { padding: "12px 6px", color: "green" }
                          }
                        >
                          {formatDot(
                            switchDotsAndCommas(
                              numberWithCommas(e && e.dataWeight)
                            )
                          )}
                        </td>
                        <td
                          className="font_td_laporan_bahan_baku"
                          style={{ padding: "12px 6px", color: "red" }}
                        >
                          {formatDot(
                            switchDotsAndCommas(
                              numberWithCommas(e && e.dataReject)
                            )
                          )}
                        </td>
                        <td className="font_td_laporan_bahan_baku">
                          {(e?.statusBahan || "").toUpperCase()}
                        </td>
                        <td
                          className="font_td_laporan_bahan_baku"
                          style={{ padding: "12px 6px" }}
                        >
                          {e && e.statusBahan === "Datang"
                            ? formatDot(
                                switchDotsAndCommas(
                                  numberWithCommas(
                                    e.weightBefore + e.dataWeight
                                  )
                                )
                              )
                            : e.statusBahan === "Kiriman"
                            ? formatDot(
                                switchDotsAndCommas(
                                  numberWithCommas(
                                    e.weightBefore - e.dataWeight
                                  )
                                )
                              )
                            : e.statusBahan === "Produksi" && !e.status
                            ? formatDot(
                                switchDotsAndCommas(
                                  numberWithCommas(
                                    e.weightBefore + e.dataWeight
                                  )
                                )
                              )
                            : e.statusBahan === "Keluar"
                            ? formatDot(
                                switchDotsAndCommas(
                                  numberWithCommas(
                                    e.weightBefore - e.dataWeight
                                  )
                                )
                              )
                            : e.status === "Keluar"
                            ? formatDot(
                                switchDotsAndCommas(
                                  numberWithCommas(
                                    e.weightBefore -
                                      e.dataWeight -
                                      dataRejectTemp
                                  )
                                )
                              )
                            : formatDot(
                                switchDotsAndCommas(
                                  numberWithCommas(
                                    e.weightBefore +
                                      e.dataWeight -
                                      dataRejectTemp
                                  )
                                )
                              )}
                        </td>
                        <td
                          className="font_td_laporan_bahan_baku"
                          style={{ padding: "12px 6px" }}
                        >
                          {(e?.updatedBy || "").split(" ")[0]}
                        </td>
                        <td
                          className="font_td_laporan_bahan_baku"
                          style={{ padding: "12px 6px" }}
                        >
                          {e && e.keterangan}
                        </td>
                        <td
                          className="font_td_laporan_bahan_baku td-expired-inventory"
                          style={
                            checkDateExp
                              ? {
                                  color: "green",
                                }
                              : {
                                  color: "red",
                                }
                          }
                        >
                          {moment(e.updateTime)
                            .utcOffset("+0700")
                            .add(87, "days")
                            .format("DD-MM-YYYY")}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <br />
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpExportMonitoring ? (
        <PopUpComponent>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex" }}>
              <div className="margin_right_27_qc">
                <p>Dari</p>
                <input
                  type="date"
                  className="date_pick_memo_ppic"
                  value={filterDateExportFrom}
                  onChange={(e) => setFilterDateExportFrom(e.target.value)}
                />
              </div>
              <div className="margin_right_27_qc">
                <p>Sampai</p>
                <input
                  type="date"
                  className="date_pick_memo_ppic"
                  value={filterDateExportUntil}
                  onChange={(e) => setFilterDateExportUntil(e.target.value)}
                />
              </div>
            </div>
            <img
              className="width_edit_logo"
              src={CloseLogo}
              onClick={() => setPopUpExportMonitoring(false)}
              alt="edit_logo"
            />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <p className="button-export-inventory">Export</p>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpNewItem ? (
        <PopUpComponent>
          <div style={{ display: "flex", justifyContent: "end" }}>
            <img
              className="width_edit_logo"
              src={CloseLogo}
              onClick={() => handleCloseAddNewItem()}
              alt="edit_logo"
            />
          </div>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <div className="wrapper-select-customer">
              <p>Customer</p>
              <select
                className="input_select"
                defaultValue="Customer"
                style={{ width: "92px", height: "30px" }}
                onChange={(e) => setNewCustomer(e.target.value)}
              >
                <option selected={newCustomer === "Pilih Customer"} disabled>
                  Customer
                </option>
                {constCustomer.map((data, i) => (
                  <option value={data} key={i} selected={newCustomer === data}>
                    {data}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Nama Barang</p>
              <input
                value={newMaterial}
                onChange={(e) => setNewMaterial(e.target.value.toUpperCase())}
                type="text"
                placeholder="Nama Barang"
                style={{ padding: "6px" }}
              />
            </div>

            <div style={{ marginRight: "6px" }}>
              <p>Kode Barang</p>
              <input
                value={newKodeBarang}
                onChange={(e) => setNewKodeBarang(e.target.value.toUpperCase())}
                type="text"
                placeholder="Kode Barang"
                style={{ padding: "6px" }}
              />
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Kode Kirim</p>
              <input
                value={newKodeKirim}
                onChange={(e) => setNewKodeKirim(e.target.value.toUpperCase())}
                type="text"
                placeholder="Kode Kirim"
                style={{ padding: "6px" }}
              />
            </div>
            <div style={{ marginRight: "6px" }}>
              <p>Satuan Barang</p>
              <select
                value={newSatuan}
                onChange={(e) => setNewSatuan(e.target.value)}
                style={{ padding: "6px" }}
              >
                <option>Satuan Barang</option>
                <option value="BOX">BOX</option>
                <option value="KTG">KTG</option>
                <option value="PALET">PALET</option>
                <option value="ZAK">ZAK</option>
              </select>
            </div>
            <div>
              <p>Isi Kemasan</p>
              <input
                style={{ padding: "6px" }}
                type="number"
                onWheel={(e) => e.target.blur()}
                placeholder="Isi Kemasan"
                value={newIsiKemasan}
                onChange={(e) => setNewIsiKemasan(Number(e.target.value))}
              />
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              className="button-kirim-new-item-inventory"
              onClick={() => handleAddNewItem()}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <div className="wrapper_header">
        <p className="title_inventory">INVENTORY</p>
        {hasRole(dataUser, "super_user") && subMenu === "barangJadi" ? (
          <div
            className="wrapper-button-tambah"
            onClick={() => setPopUpNewItem(true)}
          >
            <p className="button-tambah">+</p>
            <button className="text-button-tambah">New Item</button>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="flex_wrap-inventory">
        <CardComponent
          active={companyPick === "GS"}
          title="PT. GS"
          logo={LogoGs}
          onClick={() => setCompanyPick("GS")}
        />
        <CardComponent
          active={companyPick === "YBI"}
          title="PT. YBI"
          logo={LogoYBI}
          onClick={() => setCompanyPick("YBI")}
        />
        <CardComponent
          active={companyPick === "TBP"}
          title="PT. TBP"
          logo={LogoTBP}
          onClick={() => setCompanyPick("TBP")}
        />
        <CardComponent
          active={companyPick === "MELCO"}
          title="PT. MELCO"
          logo={LogoMelco}
          onClick={() => setCompanyPick("MELCO")}
        />
        <CardComponent
          active={companyPick === "CBI"}
          title="PT. CBI"
          logo={LogoCBI}
          onClick={() => setCompanyPick("CBI")}
        />
        {dataUser.tim === 2 ? (
          <CardComponent
            active={companyPick === "MITRA"}
            title="PT. MITRA"
            logo={LogoMitra}
            onClick={() => setCompanyPick("MITRA")}
          />
        ) : (
          ""
        )}
        <CardComponent
          active={companyPick === "TIM"}
          title="PT. TIM"
          logo={LogoTIM}
          onClick={() => setCompanyPick("TIM")}
        />
        <CardComponent
          active={companyPick === "COMPOTEC"}
          title="COMPOTEC"
          logo={LogoCompotec}
          onClick={() => setCompanyPick("COMPOTEC")}
        />
      </div>

      <div className="wrapper_sub_menu_history">
        {hasRole(
          dataUser,
          "super_user",
          "warehouse_admin",
          "warehouse_gbj_admin",
          "ppic_admin",
          "ppic_user"
        ) ? (
          <>
            <p
              className={
                subMenu === "MonitorKedatangan"
                  ? "sub_menu_history border_active_history"
                  : "sub_menu_history"
              }
              onClick={() => setSubMenu("MonitorKedatangan")}
            >
              Kedatangan
            </p>
          </>
        ) : (
          ""
        )}
        {validateRole() === "" || validateRole() === "super" ? (
          <>
            <p
              className={
                subMenu === "bahanBaku"
                  ? "sub_menu_history border_active_history"
                  : "sub_menu_history"
              }
              onClick={() => setSubMenu("bahanBaku")}
            >
              Bahan Baku
            </p>
            {hasRole(
              dataUser,
              "super_user",
              "warehouse_admin",
              "warehouse_gbj_admin",
              "ppic_admin",
              "ppic_user",
              "sp_admin"
            ) ? (
              <>
                <p
                  className={
                    subMenu === "barangJadi"
                      ? "sub_menu_history border_active_history"
                      : "sub_menu_history"
                  }
                  onClick={() => setSubMenu("barangJadi")}
                >
                  Barang Jadi
                </p>
              </>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}
      </div>

      {subMenu === "bahanBaku" ? (
        <>
          {!hasRole(dataUser, "warehouse_crusher") ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <p className="title_inventory">BAHAN BAKU PT. {companyPick}</p>
                <button
                  className="export_btn_inventory"
                  onClick={() => handleExportBahanBaku()}
                >
                  Export Bahan
                </button>
              </div>
              <TableInventory
                data={Material && Material.bahanBaku}
                setPopUpSearch={setPopUpSearch}
                setDataPickHistory={setDataPickHistory}
              />
            </>
          ) : (
            ""
          )}
          <p className="title_inventory">Crusher PT. {companyPick}</p>
          <TableInventory
            data={Crusher && Crusher.data}
            setPopUpSearch={setPopUpSearch}
            setDataPickHistory={setDataPickHistory}
          />

          {!hasRole(dataUser, "warehouse_crusher") && Pewarna ? (
            <>
              <p className="title_inventory">PEWARNA PT. {companyPick}</p>
              <TableInventory
                data={Pewarna && Pewarna.data}
                setPopUpSearch={setPopUpSearch}
                setDataPickHistory={setDataPickHistory}
              />
            </>
          ) : (
            ""
          )}
        </>
      ) : subMenu === "barangJadi" ? (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="title_inventory">
              STOCK BARANG JADI PT. {companyPick}
            </p>
            {hasRole(dataUser, "super_user") && dataUser.tim === 1 ? (
              <p className="tapal-kuda" onClick={() => setIsPinOpen(true)}>
                &#8486;
              </p>
            ) : (
              ""
            )}
            {isPinOpen ? (
              <div style={{ marginRight: "6px", alignContent: "center" }}>
                <input
                  value={isPin}
                  onChange={(e) => setIsPin(e.target.value)}
                  type="password"
                  placeholder="Pin"
                  style={{ padding: "6px" }}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="flex-wrap-justify-center-inventory">
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                className="search_box_inventory"
                type="text"
                placeholder="Cari Barang"
                value={valueSearch}
                onChange={(e) => setValueSearch(e.target.value)}
              />
              <p className="search_image_inventory">
                <img
                  src={SearchLogo}
                  style={{ width: "22px" }}
                  alt="search-logo"
                />
              </p>
              <p
                className="btn_reset_search_inventory"
                onClick={() => setValueSearch("")}
              >
                Reset
              </p>
            </div>
            {hasRole(
              dataUser,
              "super_user",
              "ppic_admin",
              "warehouse_admin",
              "warehouse_gbj_admin"
            ) ? (
              <div className="export-laporan-inventory">
                <button
                  className="export_btn_inventory"
                  style={{ background: "#9d8854" }}
                  onClick={() => setPopUpExportPenggunaanBahan(true)}
                >
                  Export Laporan
                </button>
                <button
                  className="export_btn_inventory"
                  onClick={() => handleExportBarangJadi()}
                >
                  Export Stock
                </button>
              </div>
            ) : (
              ""
            )}
          </div>

          <TableBarangJadi
            key={companyPick}
            data={dataTemp}
            isPin={isPin}
            getKodeKirim={getKodeKirim}
            onEdit={handlePickEdit}
            onHistory={handlePick}
          />
        </>
      ) : "MonitorKedatangan" ? (
        <div>
          <div style={{ display: "flex" }}>
            <select
              onChange={(e) => setFilterMonthKedatangan(e.target.value)}
              className="input_select_memo_ppic"
              value={filterMonthKedatangan}
              style={{ marginRight: "12px" }}
            >
              <option disabled>Pilih Bulan</option>
              {filterMonthConstant &&
                filterMonthConstant.map((data) => (
                  <option key={data.value} value={data.value}>
                    {data.label}
                  </option>
                ))}
            </select>
            <select
              onChange={(e) => setFilterYearKedatangan(e.target.value)}
              className="input_select_memo_ppic"
              value={filterYearKedatangan}
              style={{ marginRight: "12px" }}
            >
              <option disabled>Tahun</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
            </select>
            <select
              onChange={(e) => setJenisBarang(e.target.value)}
              className="input_select_memo_ppic"
              value={filterJenisBarang}
            >
              <option disabled>Pilih Jenis</option>
              {filterKedatangan &&
                filterKedatangan.map((element) => (
                  <option key={element} value={element}>
                    {element}
                  </option>
                ))}
            </select>
            <div style={{ display: "flex" }}>
              <p
                className="button-export-kedatangan"
                onClick={() => setPopUpExportMonitoring(true)}
              >
                Export
              </p>
            </div>
          </div>
          <p
            style={{ margin: "24px 0 0 0", color: "red", fontStyle: "italic" }}
          >
            <label style={{ color: "red" }}>&#9888; </label>Satuan untuk{" "}
            <b>Aksesoris</b> : Pcs, <b>Timah</b> : Pcs, <b>Bahan Baku</b> : Kg,{" "}
            <b>Pewarna, Cat & Thinner</b> : Gr
          </p>
          <br />
          <TableKedatangan data={dataJenisBarang} dates={dateTempListTanggal} />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Inventory;
